import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class CamionAcopladoEjes {
  static getCamionAcoplado (camion, acoplado) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `consulta_cantidad_ejes_camion_acoplado?r={"clave":{"camion":"${camion}",
      "acoplado":"${acoplado}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static altaCamionAcoplado (ejesValores = {}) {
    const {
      camion,
      acoplado,
      cantidadEjes,
      bitren,
      autodescargable,
      dimension
    } = ejesValores
    console.log('Ejes valores en modelo', ejesValores)
    const axios = getAxiosInstance()
    const promise = axios.post(`consulta_cantidad_ejes_camion_acoplado`,
      `{"valores": {"camion": "${camion}", "acoplado": "${acoplado}", 
    "cantidad_ejes": ${cantidadEjes}, "bitren": ${bitren},
    "autodescargable": ${autodescargable}, "dimension": ${dimension} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static updateCamionAcopladoEjes (autodescargable, camion, acoplado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`consulta_cantidad_ejes_camion_acoplado`, { valores: { autodescargable: autodescargable }, clave: { camion: camion, acoplado: acoplado } })
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result })
  }
}

export default CamionAcopladoEjes
